import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14.318 7.682l1.058-1.058c.001-.001.002-.002.003-.002.829-.829.829-2.172 0-3.001-.414-.414-.957-.621-1.5-.621s-1.086.207-1.5.621L5 11l-2 5 5-2 6.318-6.318zM13.879 4c.3 0 .581.117.793.329s.329.493.329.792c0 .291-.11.564-.309.773l-.374.374-1.586-1.586.354-.354c.212-.211.493-.328.793-.328zM4.795 14.205l1.057-2.643 6.173-6.173 1.586 1.586-6.173 6.173-2.643 1.057zM3 17h14v1H3v-1z',
  ],
  height: 20,
  width: 20,
});
